<template>
  <div class="div-table venue-stats">
    <div class="columns is-gapless">
      <div class="column is-12 card-header has-text-centered">
        <strong class="is-size-7-touch">Venue Stats</strong>
      </div>
    </div>
    <div
      v-for="game in paginatedVenuesStats()"
      class="columns is-gapless"
    >
      <div class="column is-12">
        <strong>
          <router-link
            :to="{name: 'VenueDetails', params: {id: game.venueid}}"
          >{{ game.venue }}</router-link>
        </strong>
        <p v-if="game.count == 1">
          Placed: {{ game.count }} time ({{ game.percent }}%)
        </p>
        <p v-if="game.count > 1">
          Placed: {{ game.count }} times ({{ game.percent }}%)
        </p>
        <progress
          class="progress is-info is-small"
          :value="game.percent"
          max="100"
        >
          {{ game.percent }}%
        </progress>
      </div>
    </div>
    <pagination
      :pagination="pagination"
      per-page="5"
      :total="player.venueStats.length"
      @paginateMinus="paginateMinus"
      @paginatePlus="paginatePlus"
    />
  </div>
</template>

<script>
  import Pagination from '../helpers/Pagination.vue'
  export default {
    components: {
      Pagination
    },
    props: ['player'],
    data () {
      return {
        pagination: 0
      }
    },
    methods: {
      paginatedVenuesStats () {
        return this.player.venueStats.slice(this.pagination, (this.pagination + 5))
      },
      paginatePlus () {
        if (this.player.venueStats.length > (this.pagination + 5)) {
          this.pagination += 5
        }
      },
      paginateMinus () {
        if (this.pagination >= 5) {
          this.pagination -= 5
        }
      }
    }
  }
</script>